import {Fragment, PureComponent} from 'react'
import PropTypes from 'prop-types'
import ParagraphLeftAlign from "../../../../shared/components/Styled/ParagraphLeftAlign.jsx"
import PrimaryButton from "../../../../shared/components/Styled/Buttons/PrimaryButton.jsx"
import FreelanceAgent from "../../../components/Agent/FreelanceAgent.jsx"
import ParagraphCenter from "../../../../shared/components/Styled/ParagraphCenter.jsx"
import TwineedsLinkedinLink from "../../../components/Linkedin/TwineedsLinkedinLink.jsx"
import {CREATE_FREELANCE_STEPS, updateCreatFreelanceStep} from "../../../../shared/containers/Freelance/setNextStep.js"
import H5TitleLeftAlign from "../../../../shared/components/Styled/H5TitleLeftAlign.jsx"

export default class ValidationStep extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    freelance: PropTypes.object.isRequired,
    submit: PropTypes.func.isRequired,
    refresh: PropTypes.func.isRequired,
  }


  goToStep = (step) => {
    updateCreatFreelanceStep(
      this.props.freelance.id,
      step,
      () => this.props.submit({
        freelance: {
          ...this.props.freelance
        },
        silentMode: true,
      })
    )
  }


  render() {
    const {agent} = this.props.freelance

    return (
      <Fragment>
        <H5TitleLeftAlign title="Je vais pouvoir valider vos informations !"/>

        <ParagraphLeftAlign className={'mt-4'}>
          Merci d'avoir renseigné toutes ces informations. Je vais pouvoir les
          {' '}<strong>valider dans les 72H</strong>{' '}afin de passer votre profil en public.
          {' '}<strong>Vous recevrez un mail dès la mise en ligne de votre profil.</strong>{' '}
          Vous pourrez alors vous connecter à votre espace dédié afin de consulter nos missions,
          déposer vos candidatures, modifier vos informations, etc.
        </ParagraphLeftAlign>

        <ParagraphLeftAlign className={'mt-4'}>
          <strong>Si votre profil n'est pas validé dans les 72H</strong>{' '}
          (hors weekend), n'hésitez pas à me contacter par téléphone ou par mail.
        </ParagraphLeftAlign>

        <ParagraphLeftAlign className={'mt-4'}>
          En attendant, pensez à nous suivre <TwineedsLinkedinLink text="Twineeds sur Linkedin"/> si ce n'est pas encore le cas,
          vous y trouverez des{' '}<strong>contenus susceptibles de vous intéresser</strong>{' '}:
          actualités de votre secteur, articles, missions, etc.
        </ParagraphLeftAlign>

        <ParagraphLeftAlign className={'mt-4'}>
          Merci et à très bientôt !
        </ParagraphLeftAlign>
        {agent && agent.id &&
          <div className="mt-4">
            <FreelanceAgent agentId={agent.id} showEmail={true}/>
          </div>
        }
        <ParagraphLeftAlign className={'mt-4'}>
          Une information à modifier ? Vous pouvez toujours les modifier en cliquant ci-dessous :
        </ParagraphLeftAlign>
        <ParagraphCenter className={'mt-4'}>
          <PrimaryButton onClick={() => this.goToStep(CREATE_FREELANCE_STEPS.MISSIONS)}>
            Modifier les informations renseignées
          </PrimaryButton>
        </ParagraphCenter>
      </Fragment>
    )
  }
}
